import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SportsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sports"}/>
}
